/**
 * This is a standard modal, but styled with a blue left column and a gift card icon
 */

import React from 'react';
import Icon from '~ComponentsImproved/Icon';
import Modal from '~ComponentsImproved/Modal';
import GiftCardIcon from '~Assets/icons/redeem.svg';
import { Card, Column, Columns } from '~Styles';

interface ThemedModalProps {
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
  width?: string;
}

export default function ThemedModal({ open, onClose, children, width }: ThemedModalProps) {
  return (
    <Modal isShowing={open} hide={onClose} zIndex={48}>
      <Card
        style={{
          width: width || '60vw',
          height: 'auto',
          overflowX: 'hidden',
          minHeight: '400px',
          background: 'transparent',
        }}
        padding="none"
        boxShadow="hard">
        <Columns style={{ height: '100%' }}>
          <Column
            width={3}
            style={{
              background: 'linear-gradient(140deg, rgba(22,66,190,1) 0%, rgba(1,33,122,1) 100%)',
              position: 'relative',
            }}
            justifyContent="center"
            alignItems="center">
            <Icon
              src={GiftCardIcon}
              height="300px"
              width="300px"
              color={'var(--colorBlueGray100)'}
              style={{
                position: 'absolute',
                opacity: 0.05,
              }}
            />
            <Icon
              src={GiftCardIcon}
              height="100px"
              width="100px"
              color={'var(--colorBlueGray100)'}
              style={{
                position: 'absolute',
              }}
            />
          </Column>
          <Column padding="xl" style={{ overflowY: 'scroll', background: '#fff' }}>
            {children}
          </Column>
        </Columns>
      </Card>
    </Modal>
  );
}
